<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('selfhelp')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit ToolKits</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p class="mb-1">Title</p>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Write Title here"
          v-model="blog_data.title"
        >
        </base-input>
        <p class="mb-1">Description</p>
        <base-input
          alternative
          class="mb-3"
          name="description"
          :rules="{ required: true }"
          placeholder="Write Description here"
          v-model="blog_data.description"
          :maxlength="500"
          @input="limitDescription"
        >
        </base-input>
        <p>
          only this much Characters are allowed
          {{ blog_data.description ? blog_data.description.length : 0 }} / 500
        </p>

        <p class="font-semibold mt-6 mb-2 text-xl">Upload Image</p>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />
        <p>Uploaded Image</p>
        <div
          class="flex cursor-pointer items-center my-2"
          v-if="blog_data.image"
        >
          <base-button type="danger" class="px-8" @click="handleRemove2">
            Remove image
          </base-button>
        </div>
        <img
          v-if="blog_data.image"
          :src="$imageURL + '/' + blog_data.image"
          alt="uploaded-image"
        />
        <!-- <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <div class="my-6">
          <p class="font-semibold mb-2 text-xl">Attach your files</p>
          <b-form-file
            v-model="file1"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".doc,.docx,.pdf,.txt"
            @input="validateFile"
          ></b-form-file>
          <div v-if="file1">
            <p class="text-success">Uploaded File:</p>
            <a :href="filePreviewUrl" target="_blank" class="text-blue-500">
              View Uploaded File
            </a>
            <div class="mt-2">
              <base-button type="danger" class="px-4" @click="removeFile">
                Remove File
              </base-button>
            </div>
          </div>
        </div>
        <div class="my-6">
          <p class="font-semibold mb-2 text-xl">Read Time(in minutes)</p>
          <base-input
            alternative
            class="mb-3"
            name="Read Time"
            :rules="{ required: true, numeric: true }"
            placeholder="Enter reading time"
            v-model="blog_data.readTime"
          >
          </base-input>
        </div>
        <div class="my-6">
          <p class="font-semibold mb-2 text-xl">Type</p>
          <base-input
            :rules="{ required: true }"
            name="Pay Type"
            v-model="blog_data.paytype"
          >
            <b-form-select
              v-model="blog_data.paytype"
              :options="optionstype"
              class="mt-3"
            ></b-form-select>
          </base-input>
        </div>
        <div
          class="mb-2"
          v-if="blog_data && blog_data.tags && blog_data.tags.length"
        >
          <b-form-group label="Tags:">
            <div class="md:flex justify-between items-center">
              <b-form-select v-model="blog_data.tags[0]" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="blog_data.tags[1]" class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="blog_data.tags[2]" class="">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              >
            </div>
          </b-form-group>
        </div>

        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="blog_data.onlyRegistered">
            <p>
              <strong>
                <p class="col-blk">
                  Click here to restrict access to this tool kit for registered
                  users only.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!blog_data.onlyRegistered ? true : false"
          >
          </multiselect>
        </div>

        <!-- <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="blog_data.metaKeyword"
            >
            </base-input>
          </div>
        </div> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      description: "",
      coverImage: "",
      file1: null,
      filter1: [],
      filter2: [],
      filter3: [],
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      selectedPageCategory: null,
      pageData: {},
      blog_data: {},
      paytype: null,
      optionstype: [
        { value: null, text: "Select" },
        { value: "Paid", text: "Paid" },
        { value: "Free", text: "Free" },
      ],
      readTime: "",
      imageErr: false,
      msg: {
        image: "",
      },
      selectedMembership: null,
      membershipFilter: [],
      onlyRegistered: false,
    };
  },
  computed: {
    ...mapState("cms", {
      selectedBlog: "selectedBlog",
      filtertags: "filtertags",
      filters: "filters",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
  },
  watch: {
    pageData(val) {
      this.blog_data = { ...val };
    },
    membershipFilter() {
      if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
        this.selectedMembership = this.membershipFilter.filter((membership) => {
          let data = this.blog_data.memberships.find(
            (member) => member._id === membership._id
          );
          // return this.blog_data.memberships.includes(membership._id);
          return data;
        });
        // console.log(this.selectedMembership);
      }
    },
  },
  methods: {
    limitDescription(event) {
      if (this.description.length > 500) {
        this.description = this.description.substring(0, 500);
      }
    },
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    validateFile(file) {
      this.fileError = false;
      this.fileErrorMessage = "";

      if (!file) {
        this.file1 = null;
        this.filePreviewUrl = "";
        return;
      }

      // if (!file.type.includes("pdf")) {
      //   this.fileError = true;
      //   this.fileErrorMessage = "Only PDF files are allowed!";
      //   this.file1 = null;
      //   this.filePreviewUrl = "";
      //   return;
      // }

      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.fileError = true;
        this.fileErrorMessage =
          "File size exceeds 10MB! Please upload a smaller file.";
        this.file1 = null;
        this.filePreviewUrl = "";
        return;
      }

      this.file1 = file;
      this.filePreviewUrl = URL.createObjectURL(file);
    },
    removeFile() {
      this.file1 = null;
      this.filePreviewUrl = "";
    },
    async onSubmit() {
      if (!this.blog_data.onlyRegistered) {
        this.selectedMembership = null;
      }
      // console.log(this.file1);
      // console.log(this.file1.type.includes("txt"));
      if (this.blog_data.file.trim() == "") {
        if (
          !this.file1.type.includes("pdf") &&
          !this.file1.type.includes("doc") &&
          !this.file1.type.includes("docx") &&
          !this.file1.type.includes("text") &&
          !this.file1.type.includes("txt") &&
          !this.file1.type.includes("odt")
        ) {
          this.$swal({
            text: "Please choose PDF, Word or Text file for attachment!",
            icon: "info",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          return;
        }
      }
      if (!this.file1) {
        this.$notify.error({
          message: "File is required!",
          position: "top-right",
        });
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();
      this.Ctags.push(
        this.blog_data.tags[0],
        this.blog_data.tags[1],
        this.blog_data.tags[2]
      );
      data.append("_id", this.blog_data._id);
      data.append("title", this.blog_data.title.replaceAll(/\s{2,}/g, " "));
      data.append("description", this.blog_data.description);
      data.append("media", this.coverImage);
      if (this.file1) data.append("file", this.file1);
      data.append("html", this.blog_data.html);
      data.append("readTime", this.blog_data.readTime);
      data.append("paytype", this.blog_data.paytype);
      data.append("pageCategory", this.blog_data.pageCategory);
      data.append("tags", JSON.stringify(_.uniq(this.Ctags)));

      // data.append("metaKeyword", this.blog_data.metaKeyword);
      // data.append("metaCanonicalTag", this.blog_data.metaCanonicalTag);
      // data.append("metaDesc", this.blog_data.metaDesc);
      // data.append("metaTitle", this.blog_data.metaTitle);
      // let formObj = {};
      // for (var pair of data.entries()) {
      //   formObj[pair[0]] = pair[1];
      // }
      // console.log(formObj);

      data.append("memberships", JSON.stringify(this.selectedMembership));
      if (this.selectedMembership !== null) {
        data.append("onlySubscribed", true);
        data.append("onlyRegistered", true);
      } else {
        data.append("onlyRegistered", this.blog_data.onlyRegistered);
        data.append("onlySubscribed", false);
      }

      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch("cms/editPage", data);
        if (editData.code == 200) {
          this.$router.push({ name: "selfhelp" });
          this.$swal.fire({
            text: "Toolkit information has been successfully updated",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedBlog;
      const filePath = this.pageData.file;
      this.file1 = null;
      this.filePreviewUrl = "";
      if (filePath) {
        const fileUrl = `${this.$imageURL}/${filePath}`;
        this.filePreviewUrl = fileUrl;

        fetch(fileUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const fileName = filePath.split("/").pop();
            const fileExtension = fileName.split(".").pop().toLowerCase();

            const mimeTypes = {
              pdf: "application/pdf",
              docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              doc: "application/msword",
              txt: "text/plain",
              odt: "application/vnd.oasis.opendocument.text",
            };
            const fileType =
              mimeTypes[fileExtension] || "application/octet-stream"; // Fallback for unknown types

            // Creating a File object with the correct MIME type
            this.file1 = new File([blob], fileName, { type: fileType });
          })
          .catch((error) => console.error("Error fetching file:", error));
      }
      // console.log(this.pageData);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleRemove2() {
      this.blog_data.image = null;
      this.coverImage = null;
      // blog_data.image
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
    this.gettagsbycategory();
  },
};
</script>
